import { getContext, setContext } from "svelte";


const CONTEXT = Symbol("DEBUG")

export function createDebugContext(): DebugContext {
  return setContext(CONTEXT, new DebugContext());
}

export function getDebugContext(): DebugContext {
  return getContext(CONTEXT)
}


export class DebugContext {
  messages: string[] = $state([])
  enabled: boolean = $state(true)
  
  constructor() {
    this
  }

  print( ...message: string[]) {
    this.messages.unshift(`${this.datestring()} - ${message.join(" ")}`)
    this.prune()
    this.messages = [...this.messages]

    return this
  }

  prune() {
    if(this.messages.length > 7 ) {
      this.messages = this.messages.splice(0, 7)
    }
    return this
  }

  clean() {
    this.messages = []

    return this
  }

  datestring() {
    const d = new Date()
    return `${d.getHours()}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  }

  enableDebug() {
    this.enabled = false
    return this
  } 

  disableDebug() {
    this.enabled= false
    return this
  }
}



function pad(input: string|number, length: number = 2, pad: string = "0") {
  while( String(input).length < length) {
    input = pad + input
  }
  return input
} 